import { useEffect, useState } from "react"
import { Helmet } from 'react-helmet-async'
import RightSidebar from "components/Checkout/RightSidebar"
import ShippingInfo from "components/Checkout/ShippingInfo"
import CheckoutProductList from "components/Checkout/CheckoutProductList"
import DeliveryMethod from "components/Checkout/DeliveryMethod"
import PaymentMethod from "components/Checkout/PaymentMethod"
import OrderNote from "components/Checkout/OrderNote"
import { useLocation } from "react-router-dom"
import type { ProductFull } from "components/Cart/CartAction"
import type { Vourcher, VoucherQuoteResponse } from "api/VourcherType"

export default function Checkout() {
    const location = useLocation();
    const { selectedItems = [], selectedVouchers = [], selectedPointVoucherGiftIds = [], selectedPointProductGiftIds = [], quoteSnapshot = null }: {
        selectedItems?: ProductFull[];
        selectedVouchers?: Vourcher[];
        selectedPointVoucherGiftIds?: number[];
        selectedPointProductGiftIds?: number[];
        quoteSnapshot?: VoucherQuoteResponse | null;
    } = location.state || {};

    // Lifted state
    const [fullname, setFullname] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [note, setNote] = useState("");
    const [openAddressModalSignal, setOpenAddressModalSignal] = useState(0);


    useEffect(() => {
        document.body.classList.add("NoneFooter");

        return () => {
            document.body.classList.remove("NoneFooter");
        };
    }, []);
    return (
        <>
            <Helmet>
                <title>Thanh toán - Dược Tâm Hạnh</title>
                <meta name="description" content="Hoàn tất thanh toán đơn hàng tại Dược Tâm Hạnh." />
            </Helmet>
            <div className="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthLg mobile-mt-24 ">
                <div className="styles_wrapper_gray__f8P4_">
                    <div className="styles_payment_wrapper__R7Bz9">
                        <div className="MuiGrid-root styles_payment_grid__kN77N MuiGrid-container">
                            <div className="MuiGrid-root styles_itemLeft__fZHT_ MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-md-9">
                                <div id="delivery__info_form" className="styles_wMax__iGEzJ">
                                    <ShippingInfo 
                                        fullname={fullname}
                                        phone={phone}
                                        address={address}
                                        openAddressModalSignal={openAddressModalSignal}
                                        onUpdateInfo={(name, ph, addr) => {
                                            setFullname(name);
                                            setPhone(ph);
                                            setAddress(addr);
                                        }}
                                    />
                                </div>
                                <CheckoutProductList selectedItems={selectedItems} />
                                {/* <DeliveryMethod /> */}
                                <PaymentMethod paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} />
                                <OrderNote note={note} setNote={setNote} />
                            </div>
                            <RightSidebar 
                                selectedItems={selectedItems} 
                                selectedVouchers={selectedVouchers}
                                selectedPointVoucherGiftIds={selectedPointVoucherGiftIds}
                                selectedPointProductGiftIds={selectedPointProductGiftIds}
                                quoteSnapshot={quoteSnapshot}
                                fullname={fullname}
                                phone={phone}
                                address={address}
                                paymentMethod={paymentMethod}
                                note={note}
                                onRequireShippingInfo={() => {
                                    setOpenAddressModalSignal((prev) => prev + 1);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
